<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.article')"
    :batch-actions="batchActions"
    resource="articles"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/articles.js';
import { columnsExtend as commentableCommentDatumColumnsExtend } from '../admin_entities/commentable_comment_datum_detail.js';
import _ from 'lodash';

@Component
export default class Articles extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      'keyword'
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const [commentsCount] = commentableCommentDatumColumnsExtend(['comments_count'])
    const array = [
      type === 'show' && 'id',
      'title',
      'subtitle',
      'note',
      'cover',
      'author',
      'source',
      'share_desc',
      type === 'show' && 'content_type',
      type === 'show' && { key: 'content', renderCell: { component: 'html' }  },
      type === 'show' && { key: 'markdown_content', renderCell: { component: 'richText', props: { type: 'markdown' } }  },
      type === 'show' && 'recommend_posts',
      { ...commentsCount, prop: 'commentable_comment_datum.comments_count' },
      'likes_count',
      'views_count',
      'stars_count',
      'shares_count',
      'comments_count',
      'published_at',
      'created_at',
      'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
      'title',
      'subtitle',
      'note',
      {
        key: 'cover',
        renderCell: {
          hint: `${this.$t('suggestSize')}: 691x370`,
          props: {
            cropper: {
              width: 691,
              height: 295
            }
          }
        }
      },
      'author',
      'source',
      {
        key: 'share_desc',
        renderCell: {
          hint: this.$t('hint.shareDescLengthHint'),
        }
      },
      'content_type',
      {
        key: 'content',
        renderCell: {
          component: 'editor'
        }
      },
      {
        key: 'markdown_content',
        renderCell: {
          component: 'markdownEditor'
        }
      },
      'recommend_post_ids',
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove, reload }) {
    const handlePublish = async (id) => {
      await this.$autoLoading(this.$request.put(`/posts/${id}/published_at_to_time_current`));
      this.$message.success(this.$t('operateSuccess'));
      reload();
    }
    const handleUnpublish = async (id) => {
      await this.$autoLoading(this.$request.put(`/posts/${id}/published_at_to_nil`));
      this.$message.success(this.$t('operateSuccess'));
      reload();
    }

    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'articles.edit', params: { id: row.id } }
        }
      },
      {
        component: 'routeButton',
        props: {
          label: '查看评论',
          to: { name: 'commments.index', params: { commentType: 'Article', id: row.id } }
        }
      },
      !row.published_at && {
        component: 'confirmButton',
        props: {
          label: this.$t('post.publish'),
          type: 'primary',
          can: 'articles.update'
        },
        on: {
          confirm: () => handlePublish(row.id)
        }
      },
      row.published_at && {
        component: 'confirmButton',
        props: {
          label: this.$t('post.unpublish'),
          type: 'primary',
          can: 'articles.update'
        },
        on: {
          confirm: () => handleUnpublish(row.id)
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'articles.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }

  /**
    * @param {Object} scope -表格 scope 数据
    * @param {Object} scope.selection - 表格已选择行数据
    * @param {Object} sourcePageScope
    * @param {Function} sourcePageScope.remove - sourcePage删除方法
    * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
    */
  batchActions({ selection }, { resource }) {
    const exportClick = async (selection) => {
      if (selection.length === 0) {
        await this.$request.get(`/${resource}/export`, { ...this.$route.query });
      } else {
        await this.$request.get(`/${resource}/export`, { ...this.$route.query, id_in: _.map(selection, item => item.id) });
      }

      this.$message.success(this.$t('exporting'));
    }

    return [
      () => <el-button type='primary' onClick={() => exportClick(selection)}><i class='el-icon-download'></i>导出</el-button>
    ];
  }
}

export const route = [
  {
    path: '/articles',
    name: 'articles.index',
    component: Articles,
    props: {
      type: 'index',
    }
  },
  {
    path: '/articles/new',
    name: 'articles.new',
    component: Articles,
    props: {
      type: 'new',
    }
  },
  {
    path: '/articles/:id',
    name: 'articles.show',
    component: Articles,
    props: {
      type: 'show',
    }
  },
  {
    path: '/articles/:id/edit',
    name: 'articles.edit',
    component: Articles,
    props: {
      type: 'edit'
    }
  }
]
</script>
